'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';

const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'auto' });
};

export function ScrollToTop() {
    const pathname = usePathname();
    const prevPath = useRef<string>('');
    const isInitialMount = useRef(true);

    // Check if we're on the homepage
    const isHomepage = pathname === '/en' || pathname === '/';

    // Function to scroll to top
    useEffect(() => {
        // Always scroll to top on initial mount (handles page load/refresh)
        scrollToTop();
        isInitialMount.current = false;
    }, []);

    useEffect(() => {
        // Handle ALL navigation - scroll to top on every pathname change
        scrollToTop();
        prevPath.current = pathname;
    }, [pathname]);

    useEffect(() => {
        // Always scroll to top when on homepage
        if (isHomepage) {
            scrollToTop();
        }
    }, [isHomepage]);

    // Handle browser back/forward navigation
    useEffect(() => {
        const handlePopState = () => {
            // Use requestAnimationFrame to ensure DOM is ready
            requestAnimationFrame(() => {
                scrollToTop();
            });
        };

        // Listen for popstate events (back/forward buttons)
        window.addEventListener('popstate', handlePopState);

        // Also listen for pageshow event which fires on back/forward navigation
        const handlePageShow = (event: PageTransitionEvent) => {
            if (event.persisted) {
                // Page was loaded from cache (back/forward)
                requestAnimationFrame(() => {
                    scrollToTop();
                });
            }
        };

        window.addEventListener('pageshow', handlePageShow);

        return () => {
            window.removeEventListener('popstate', handlePopState);
            window.removeEventListener('pageshow', handlePageShow);
        };
    }, []);

    return null;
}
